<div class="row-auto wrapper">
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <h2 *ngIf="!primaryStateStandardsName && hasStateStandards" class="section-title">State</h2>
        <h2 *ngIf="primaryStateStandardsName" class="section-title">
            {{ primaryStateStandardsName }}
        </h2>
        <!-- #region Advices/Prompt(s) -->
        <div *ngIf="!isUserLoggedIn || !isUserLocalized" class="advices-wrapper">
            <div class="login-prompt">
                <div class="login-prompt-text">Want to see state standards for this resource?</div>
                <div *ngIf="!isUserLoggedIn" class="sign-in">
                    <button
                        (click)="openLoginModal()"
                        class="selenium-standards-sign-in gtm-standards-sign-in"
                    >
                        Sign In
                    </button>
                </div>
                <div *ngIf="isUserLoggedIn && !isUserLocalized" class="choose-station">
                    <button
                        (click)="openLocalizationModal()"
                        class="selenium-standards-choose-station gtm-standards-choose-station"
                    >
                        Choose Station
                    </button>
                </div>
            </div>
        </div>
        <div
            *ngIf="isUserLoggedIn && isUserLocalized"
            [ngClass]="{ 'change-station-no-standards': !hasStateStandards }"
            class="change-station-wrapper"
        >
            <div [ngClass]="{ 'mt-xs-5 mt-lg-0': !hasStateStandards }" class="text">
                <span *ngIf="!hasStateStandards" class="fw-bold"
                    >This resource has not been aligned to any standards from
                    {{ stateStandards }}.</span
                >
                <span *ngIf="hasStateStandards">Want to see another state’s standards?</span>
            </div>
            <button
                (click)="openLocalizationModal()"
                [ngClass]="{ 'mb-5 mt-xs-2 mt-lg-0': !hasStateStandards }"
                class="selenium-standard-change-station-btn gtm-standard-change-station-btn"
            >
                <app-icon [type]="'Cog'"></app-icon>
                Change Station
            </button>
        </div>

        <ng-container
            [ngTemplateOutletContext]="{
                $implicit: {
                    standardData: primaryStateStandards,
                    standardType: 'state',
                    wrapperClassName: 'primary-state',
                },
            }"
            [ngTemplateOutlet]="standardsDisplay"
        ></ng-container>

        <h2 *ngIf="nationalStandards.length" class="category">Nationwide</h2>
        <ng-container
            [ngTemplateOutletContext]="{
                $implicit: {
                    standardData: nationalStandards,
                    standardType: 'national',
                    wrapperClassName: 'national',
                },
            }"
            [ngTemplateOutlet]="standardsDisplay"
        ></ng-container>

        <h4 *ngIf="secondaryStateStandards.length" class="category">
            {{ secondaryStateStandardsName }}
        </h4>
        <ng-container
            [ngTemplateOutletContext]="{
                $implicit: {
                    standardData: secondaryStateStandards,
                    standardType: 'secondary',
                    wrapperClassName: 'secondary-state',
                },
            }"
            [ngTemplateOutlet]="standardsDisplay"
        ></ng-container>

        <ng-template #standardsDisplay let-standardsList>
            <div *ngFor="let group of standardsList.standardData; let iterator = index">
                <h3 class="subcategory">
                    {{ group.name }}
                    <span class="counter">({{ group.length }})</span>
                </h3>
                <div *ngFor="let standard of group.standards; let i = index">
                    <ng-container *ngIf="standard.length > 0">
                        <div *ngFor="let grade of standard; let j = index">
                            <h4
                                *ngIf="j === 0"
                                class="fw-bold d-block text-navy-blue mt-0 my-2 grades"
                            >
                                Grades {{ grade.grade_bands }}
                            </h4>
                            <div *ngIf="grade.expanded || j === 0" class="standard ms-4">
                                <ng-template #tooltipContent>
                                    <p class="mb-0 pb-0 fw-bold" *ngIf="grade.parent_num">
                                        {{ grade.parent_num }}
                                    </p>
                                    <span>{{ grade.parent_description }}</span>
                                </ng-template>
                                <h4
                                    *ngIf="grade.num"
                                    class="d-inline text-primary fw-bold show-tooltip"
                                >
                                    <span class="text-navy-blue">{{ grade.num }} </span>
                                    <span
                                        *ngIf="grade.parent_num"
                                        triggers="click:blur"
                                        [ngbTooltip]="tooltipContent"
                                        placement="top-left"
                                        class="anchor-statement"
                                    >
                                        <app-icon class="pe-1 ms-4 me-2" type="Eye"></app-icon>
                                        See anchor statement
                                    </span>
                                </h4>
                                <span class="standard-text d-block">{{ grade.description }}</span>
                                <a class="standard-num mt-2" href="{{ grade.link }}">
                                    All “{{ grade.num }}” resources
                                    <app-icon type="Arrow-right"></app-icon>
                                </a>
                            </div>
                            <div
                                class="{{
                                    standardsList.wrapperClassName
                                }}-standards-buttons-wrapper"
                                *ngIf="standard.length > 1 && j === standard.length - 1"
                            >
                                <app-opposed-buttons-set
                                    (valueChange)="
                                        displayStandards($event, group, grade.grade_bands)
                                    "
                                    [firstText]="
                                        'See all (' +
                                        standard.length +
                                        ') Grades ' +
                                        grade.grade_bands +
                                        ' standards '
                                    "
                                    [secondText]="
                                        'See fewer Grades ' + grade.grade_bands + ' standards'
                                    "
                                    class="selenium-show-all-{{
                                        standardsList.standardType
                                    }}-standards
                                    gtm-show-all-{{
                                        standardsList.standardType
                                    }}-standards gtm-show-all-{{ grade.grade_bands }}-standards"
                                >
                                </app-opposed-buttons-set>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </ng-template>
    </div>
</div>
